import React from "react"
import { Container } from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import DatatableTables from "./DatatableTables"
import MetaTag from "components/Common/Meta-tag"

function Vehicles() {
  return (
    <>
      <MetaTag title={"All Vehicles"} />

      <div className="page-content">
        <Breadcrumbs
          title="Dashboard"
          breadcrumbItem="All Vehicles"
        // isBranchFilter
        />
        <Container fluid>
          <div className="container-fluid">
            <DatatableTables />
          </div>
        </Container>
      </div>
    </>
  )
}

export default Vehicles
